import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import { AuthedRoute, UnauthedRoute } from 'containers/App/components/RouteWrapper/AppRouteWrapper';
import { ROUTE_PATHS } from 'config/constants';
import {
    AsyncLogin, AsyncPasswordReset, AsyncConfirmEmail,
    AsyncLandingMain, AsyncLandingOrg, AsyncFaq, AsyncNewsFeed, AsyncFactios, AsyncDashboardOrg,
    AsyncFactio, AsyncFactioCreate, AsyncFactioEdit, AsyncCampaigns, AsyncCampaign, AsyncCampaignCreate,
    AsyncCampaignEdit, AsyncCampaignEventCreate, AsyncCampaignEventEdit, AsyncNotifications, AsyncOnboarding,
    AsyncOnboardingAfter, AsyncProfile, AsyncAdmin, AsyncMyReps, AsyncDashboardRep, AsyncNotFound, AsyncCampaignEvents,
    AsyncAdminGMManager, AsyncGm, AsyncCampaignIframe
} from './AppScreens';

export default class AppRouter extends Component {
    static propTypes = {
        isAuthed: PropTypes.bool.isRequired
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.isAuthed !== nextProps.isAuthed) {
            return true;
        }

        return false;
    }

    render() {
        const { isAuthed } = this.props;

        return (
            <Switch>
                <UnauthedRoute path={ROUTE_PATHS.LANDING} exact={true} component={AsyncLandingMain} isAuthed={isAuthed} />
                <UnauthedRoute path={ROUTE_PATHS.LANDING_ORG} exact={true} component={AsyncLandingOrg} isAuthed={isAuthed} />

                <UnauthedRoute path={ROUTE_PATHS.ONBOARDING} exact={true} component={AsyncOnboarding} isAuthed={isAuthed} />
                <UnauthedRoute path={ROUTE_PATHS.ONBOARDING_CITIZEN} exact={true} component={AsyncOnboarding} isAuthed={isAuthed} />
                <UnauthedRoute path={ROUTE_PATHS.ONBOARDING_ORGANIZATION} exact={true} component={AsyncOnboarding} isAuthed={isAuthed} />
                <UnauthedRoute path={ROUTE_PATHS.ONBOARDING_REP} exact={true} component={AsyncOnboarding} isAuthed={isAuthed} />
                <UnauthedRoute path={ROUTE_PATHS.LOGIN} exact={true} component={AsyncLogin} isAuthed={isAuthed} />
                <UnauthedRoute path={ROUTE_PATHS.PASSWORD_RESET} exact={true} component={AsyncPasswordReset} isAuthed={isAuthed} />

                <Route path={ROUTE_PATHS.CONFIRM_EMAIL} component={AsyncConfirmEmail} isAuthed={isAuthed} />
                <Route path={ROUTE_PATHS.FAQ} exact={true} component={AsyncFaq} />
                <Route path={ROUTE_PATHS.NEWSFEED} exact={true} component={AsyncNewsFeed} isAuthed={isAuthed} />
                <Route path={ROUTE_PATHS.FACTIOS} exact={true} component={AsyncFactios} />
                <Route path={ROUTE_PATHS.FACTIO()} component={AsyncFactio} />
                <Route path={ROUTE_PATHS.CAMPAIGNS} exact={true} component={AsyncCampaigns} />
                <Route path={ROUTE_PATHS.CAMPAIGN_EVENTS()} exact={true} component={AsyncCampaignEvents} />
                <Route path={ROUTE_PATHS.CAMPAIGN()} component={AsyncCampaign} />
                <Route path={ROUTE_PATHS.CAMPAIGN_IFRAME()} component={AsyncCampaignIframe} />
                <Route path={ROUTE_PATHS.GM()} component={AsyncGm} />

                <AuthedRoute path={ROUTE_PATHS.ONBOARDING_AFTER} exact={true} component={AsyncOnboardingAfter} isAuthed={isAuthed} />
                <AuthedRoute path={ROUTE_PATHS.NOTIFICATIONS} exact={true} component={AsyncNotifications} isAuthed={isAuthed} />
                <AuthedRoute path={ROUTE_PATHS.MY_REPS} exact={true} component={AsyncMyReps} isAuthed={isAuthed} />
                <AuthedRoute path={ROUTE_PATHS.FACTIOS_MY} exact={true} component={AsyncFactios} isAuthed={isAuthed} />
                <AuthedRoute path={ROUTE_PATHS.FACTIO_CREATE} exact={true} component={AsyncFactioCreate} isAuthed={isAuthed} />
                <AuthedRoute path={ROUTE_PATHS.FACTIO_EDIT()} exact={true} component={AsyncFactioEdit} isAuthed={isAuthed} />
                <AuthedRoute path={ROUTE_PATHS.CAMPAIGNS_MY} exact={true} component={AsyncCampaigns} isAuthed={isAuthed} />
                <AuthedRoute path={ROUTE_PATHS.CAMPAIGN_CREATE()} exact={true} component={AsyncCampaignCreate} isAuthed={isAuthed} />
                <AuthedRoute path={ROUTE_PATHS.CAMPAIGN_CREATE('')} exact={true} component={AsyncCampaignCreate} isAuthed={isAuthed} />
                <AuthedRoute path={ROUTE_PATHS.CAMPAIGN_EDIT()} exact={true} component={AsyncCampaignEdit} isAuthed={isAuthed} />
                <AuthedRoute path={ROUTE_PATHS.CAMPAIGN_EVENT_CREATE()} exact={true} component={AsyncCampaignEventCreate} isAuthed={isAuthed} />
                <AuthedRoute path={ROUTE_PATHS.CAMPAIGN_EVENT_EDIT()} exact={true} component={AsyncCampaignEventEdit} isAuthed={isAuthed} />

                <AuthedRoute path={ROUTE_PATHS.DASHBOARD_REP_CAMPAIGNS} exact={true} component={AsyncDashboardRep} isAuthed={isAuthed} />
                <AuthedRoute path={ROUTE_PATHS.DASHBOARD_REP_CAMPAIGNS_SUPPORT()} exact={true} component={AsyncDashboardRep} isAuthed={isAuthed} />
                <AuthedRoute path={ROUTE_PATHS.DASHBOARD_REP_SURVEYS} exact={true} component={AsyncDashboardRep} isAuthed={isAuthed} />

                <AuthedRoute path={ROUTE_PATHS.DASHBOARD_ORG_SUPPORT} exact={true} component={AsyncDashboardOrg} isAuthed={isAuthed} />
                <AuthedRoute path={ROUTE_PATHS.DASHBOARD_ORG_ALERT} exact={true} component={AsyncDashboardOrg} isAuthed={isAuthed} />

                <AuthedRoute path={ROUTE_PATHS.PROFILE()} exact={true} component={AsyncProfile} isAuthed={isAuthed} />
                <AuthedRoute path={ROUTE_PATHS.ADMIN} exact={true} component={AsyncAdmin} isAuthed={isAuthed} />
                <AuthedRoute path={ROUTE_PATHS.ADMIN_RPS} exact={true} component={AsyncAdmin} isAuthed={isAuthed} />
                <AuthedRoute path={ROUTE_PATHS.ADMIN_GM_MANAGER()} exact={true} component={AsyncAdminGMManager} isAuthed={isAuthed} />
                <AuthedRoute path={ROUTE_PATHS.ADMIN_GM_MANAGER('')} exact={true} component={AsyncAdminGMManager} isAuthed={isAuthed} />

                <Route component={AsyncNotFound} />
            </Switch>
        );
    }
}
